import { defineReactiveModel, Persistable, UserMixin, hasMany, hasOne } from "vue-app-utils";
import Model from "@/models/model";

const User = {
  extends: Model,
  mixins: [
    Persistable,
    UserMixin,
    hasMany("tournaments", {
      orderBy: [["createdAt", "desc"]]
    }),
    hasMany("leagues", {
      orderBy: [["createdAt", "desc"]]
    }),
    hasOne("scorecard")
  ],
  data () {
    return {
      agreedToTerms: false,
      role: "",
      playerName: "",
      singles: true
    };
  }
};

export default defineReactiveModel(User);
